import React, { Fragment, useState, useEffect } from "react";
import { Layout } from "@cloud/atom-ui";
import "./style.m.less";
import HomeHeader from "../HomeHeader";
import SiderMenu from "../SiderMenu";
import { ROLE_TYPE } from '../../utils/constant';
import useMappedState from '@src/utils/useMappedState';
import history from "../../utils/history";
import { queryString } from '../../utils/common';
import { getIsLogin } from "../../utils/isLogin";
import webConfig from '../../configs/web.config';
import BindHeader from '../BindHeader';

export default props => {
  const { children, layout, leftSlider: LeftSlider } = props;
  const { Header, Content, Sider } = Layout;
  const { roleType } = useMappedState('root');
  const pathKey = location?.hash?.match(/\/([^?]+)/)?.[1];
  const operateType = queryString("operateType");
  // 能力的路由一致为/appCapabilitiesList，根据operateType判断
  const key = ['appCapabilitiesList', 'appCapabilitiesWecode', 'appCapabilitiesAddPush', 'appCapabilitiesEdit'].includes(pathKey) ? operateType : pathKey;
  const [currentKey, setCurrentKey] = useState(key);

  useEffect(() => {
    if (layout === 'inner' && roleType === ROLE_TYPE.noPermission) {
      history.push('/appList');
    }
  }, [layout, roleType]);

  useEffect(() => {
    if (webConfig.isRedBlue) {
      getIsLogin().then(isLogin => {
        if (!isLogin) {
          location.href = webConfig.goLoginURl(window.location.href);
        }
      });
    }
  }, []);

  const layouts = {
    outer: (
      <Layout style={{ width: '100%', height: '100%' }}>
        <Header>
          <HomeHeader />
        </Header>
        <Content style={{ margin: 0 }}>{children}</Content>
      </Layout>
    ),
    inner: (
      <Layout style={{ width: '100%', height: '100%' }}>
        <Header>
          <HomeHeader />
          <BindHeader />
        </Header>
        <Content style={{ margin: 0 }}>
          <Layout style={{ width: '100%' }}>
            {LeftSlider ? <LeftSlider /> : (
              <Sider className="siderMenuContent scrollbarStyle">
                <SiderMenu currentKey={currentKey} setCurrentKey={setCurrentKey} />
              </Sider>
            )}
            <Content className="contentScrollbarStyle" style={{ margin: 0, padding: 20, height: "calc(100vh - 120px)", overflowY: "scroll" }}>
              {children}
            </Content>
          </Layout>
        </Content>
      </Layout>
    ),
    default: <Fragment>{children}</Fragment>
  };
  return layouts[layout] || layouts.default;
};
